import React from 'react';
import { IoCopy } from 'react-icons/io5';
import Media from '../../components/Media';
import Controls from './Controls';
import ImageHotspot from './ImageHotspot';
import { VideoPlayer } from '../../components/VideoPlayer/VideoPlayer';
import DocumentPost from '../DocumentPost';

export default function HotspotMedia(props) {
  const {
    row,
    isModal = false,
    style = {},
    playFunctionality,
    view,
    autoPlay,
    preload,
    showMute,
    layout,
    onVideoComplete,
    isMuted,
    backgroundBlur,
  } = props;
  const [postNumber, setPostNumber] = React.useState(0);
  const [hotspots, setHotspots] = React.useState([]);
  const products = row?.products;
  React.useEffect(() => {
    if (products) {
      const hotspotsTemp = [];
      products?.map((row) => {
        if (row.id && row?.coords?.x != -1) {
          hotspotsTemp.push({
            ...row?.coords,
            data: row,
            id_from_product: row?.id_from_product,
          });
        }
      });
      setHotspots(hotspotsTemp);
    }
  }, [products]);

  React.useEffect(() => {
    let timer;
    if (row?.media_type == 'CAROUSEL_ALBUM') {
      timer = setInterval(() => {
        setPostNumber((e) => {
          const totalPost = row?.children?.data?.length;
          if (e == totalPost - 1) return 0;
          return e + 1;
        });
      }, 4000);
    }
    return () => clearInterval(timer);
  });

  return (
    <>
      {row?.media_type == 'document' ? (
        <DocumentPost row={row} layout={layout} />
      ) : row?.media_type == 'IMAGE' ? (
        <ImageHotspot
          hotspots={hotspots}
          alt={row?.caption}
          src={row?.src || row?.media_url || row.thumbnail_url}
          id={0}
          style={style}
          layout={layout}
          backgroundBlur={backgroundBlur}
        />
      ) : row?.media_type == 'CAROUSEL_ALBUM' ? (
        <idk-div class="zid-relative zid-h-full">
          {row?.children?.data?.length > 0 &&
            (row?.children?.data?.[postNumber]?.media_type === 'IMAGE' ||
            row?.children?.data?.[postNumber]?.type === 'IMAGE' ? (
              <>
                <ImageHotspot
                  hotspots={hotspots}
                  src={row?.children?.data[postNumber]?.media_url || row?.children?.data[postNumber]?.url}
                  id={postNumber}
                  style={style}
                  alt={row?.caption}
                  layout={layout}
                  backgroundBlur={backgroundBlur}
                />
                {isModal && <Controls postNumber={postNumber} setPostNumber={setPostNumber} row={row} />}
              </>
            ) : (
              <>
                <VideoPlayer
                  videoId={row?.id}
                  onEnded={onVideoComplete}
                  source={row.source}
                  preload={preload}
                  autoPlay={autoPlay}
                  showMute={showMute}
                  videoSource={row?.children?.data[postNumber]?.media_url + '#t=0.2'}
                  poster={row?.thumbnail_url || row?.thumbnail}
                  previewUrl={row?.previewUrl}
                  isMuted={isMuted}
                  style={{ margin: 0, width: '100%', height: '100%', objectFit: 'cover', ...style }}
                />
                {isModal && <Controls postNumber={postNumber} setPostNumber={setPostNumber} row={row} />}
              </>
            ))}
          {!isModal && view != 'stories' && view != 'premium2' && (
            <IoCopy
              style={{ position: 'absolute', top: '5px', right: '5px', transform: 'rotate(180deg)' }}
              size={20}
              color="#fff"
            />
          )}
        </idk-div>
      ) : (
        <Media
          onVideoComplete={onVideoComplete}
          autoPlay={autoPlay}
          preload={preload}
          showMute={showMute}
          alt={row?.caption}
          row={row}
          style={{ width: '100%', height: '100%', objectFit: 'cover', ...style }}
          isModal={isModal}
          playFunctionality={playFunctionality}
          view={view}
          isMuted={isMuted}
        />
      )}
    </>
  );
}
